"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _cnbuilder = require("cnbuilder");
var _IconLabelModule = _interopRequireDefault(require("./IconLabel.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const IconLabel = _ref => {
  let {
    icon,
    iconColor,
    label,
    variant,
    classNameRoot,
    classNameIcon,
    classNameLabel,
    testAttrRoot,
    testAttrIcon,
    testAttrLabel
  } = _ref;
  const iconFill = variant === 'heading' ? 'base' : iconColor;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _cnbuilder.cnb)(_IconLabelModule.default.root, {
      [_IconLabelModule.default.heading]: variant === 'heading'
    }, classNameRoot),
    "data-testid": testAttrRoot,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _cnbuilder.cnb)(_IconLabelModule.default.icon, _IconLabelModule.default[iconFill], classNameIcon),
      "data-testid": testAttrIcon,
      children: icon
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _cnbuilder.cnb)(_IconLabelModule.default.label, classNameLabel),
      "data-testid": testAttrLabel,
      children: label
    })]
  });
};
IconLabel.defaultProps = {
  iconColor: 'base',
  variant: 'default'
};
var _default = exports.default = IconLabel;